var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useState, useCallback } from "react";
import { useMutation } from "react-query";
import { useIntl } from "react-intl";
import { useOkapiKy } from "@folio/stripes/core";
/**
 * Shared hook for reports whose result is rendered on screen (annual, SČKN,
 * IPA, WIPO, Kult 15-01 preview). These are fast aggregations the backend
 * answers synchronously; the file reports run as background jobs instead
 * (see `useReportMutation`).
 */
export var useInlineReportMutation = function (_a) {
    var generateReport = _a.generateReport, successMessageId = _a.successMessageId, errorMessageId = _a.errorMessageId;
    var formatMessage = useIntl().formatMessage;
    var ky = useOkapiKy();
    var _b = useState(false), errorModalOpen = _b[0], setErrorModalOpen = _b[1];
    var _c = useState(""), errorMessage = _c[0], setErrorMessage = _c[1];
    var _d = useState(""), successMessage = _d[0], setSuccessMessage = _d[1];
    var clearSuccessMessage = useCallback(function () { return setSuccessMessage(""); }, []);
    var closeErrorModal = useCallback(function () { return setErrorModalOpen(false); }, []);
    var _e = useMutation(function (formData) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, generateReport(ky, formData)];
    }); }); }, {
        onMutate: function () { return setSuccessMessage(""); },
        onSuccess: function () {
            setSuccessMessage(formatMessage({ id: successMessageId }));
        },
        onError: function () {
            setSuccessMessage("");
            setErrorMessage(formatMessage({ id: errorMessageId }));
            setErrorModalOpen(true);
        },
    }), mutate = _e.mutate, isLoading = _e.isLoading, data = _e.data;
    return {
        mutate: mutate,
        isLoading: isLoading,
        data: data,
        successMessage: successMessage,
        clearSuccessMessage: clearSuccessMessage,
        errorModalOpen: errorModalOpen,
        errorMessage: errorMessage,
        closeErrorModal: closeErrorModal,
    };
};
